module.exports = __webpack_public_path__ + "01_mole.a3e38534.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer2/01_mole.png
// module id = lPT+
// module chunks = 0